var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "report-calendar" } }, [
    _c("div", { staticClass: "overall-content" }, [
      _c("div", { staticClass: "chart-container" }, [
        _c("div", { staticClass: "report-card" }, [
          _c("div", { staticClass: "report-card-header" }, [
            _c(
              "div",
              { staticClass: "report-card-icon calendar-icon" },
              [_c("md-icon", [_vm._v("event")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report-card-title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.calendarEvents")))]),
              _vm._v(" "),
              _c("p", { staticClass: "report-card-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("report.calendarEventsDesc"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-card-body" },
            [_c("CalendarEventsChart", { attrs: { filters: _vm.filters } })],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "report-card" }, [
          _c("div", { staticClass: "report-card-header" }, [
            _c(
              "div",
              { staticClass: "report-card-icon reservation-icon" },
              [_c("md-icon", [_vm._v("book_online")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report-card-title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.reservationEvents")))]),
              _vm._v(" "),
              _c("p", { staticClass: "report-card-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("report.reservationEventsDesc"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-card-body" },
            [_c("ReservationEventsChart", { attrs: { filters: _vm.filters } })],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }